<template>
  <v-card>
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="items"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      sort-by="level"
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Fireflies V2"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Config
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-firefly-v2-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {FireflyModelV2} from "@/modules/redactor/models/firefly/FireflyModelV2";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RFireflyV2Dialog from "@/modules/redactor/views/firefly/r-firefly-v2-dialog.vue";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  name: "r-firefly-v2-page",
  components: {RDialogPreviewCollection, AcDataTable, RFireflyV2Dialog},

  data: () => ({
    search: "",
    headers: [
      {text: "Level", value: "level.string"},
      {text: "Kind", value: "kind.name"},
      {text: "Delay", value: "delayTime"},
      {text: "Cooldown", value: "cooldownTime"},
      {text: "ResetTime", value: "resetTime"},

      {text: "Density", value: "density"},
      {text: "Quantity", value: "quantity"},
      {text: "Interval", value: "interval"},
      {text: "Status", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(FireflyModelV2)
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushFireflyV2(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushFireflyV2(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushFireflyV2(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeFireflyV2(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkFireflyV2s(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushFireflyV2(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    row_duplicate(item) {
      return this.items.find(v => {
        return v.uid !== item.uid && v.kind.equal(item.kind) && v.level.collide(item.level);
      });
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, FireflyModelV2, "firefly-v2")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getFirefliesV2();
  }
}
</script>